export const DOCUMENT_LINK_FILENAME_PARAM = "filename";

// Highlight applied to the row matching the shared `?filename=` link.
// `!` keeps the yellow visible even over the table row hover colour.
export const DOCUMENT_HIGHLIGHT_ROW_CLASS = "!bg-yellow-100";

// Lets long file names wrap (breaking on characters such as `_`) and renders
// them larger, instead of truncating with an ellipsis.
export const DOCUMENT_FILE_NAME_LABEL_CLASS =
  "!overflow-visible !whitespace-normal break-all !text-lg";

export const buildDocumentLink = ({
  origin = "",
  pathname = "",
  fileName = "",
} = {}) => {
  const base = `${origin}${pathname}`;
  return `${base}?${DOCUMENT_LINK_FILENAME_PARAM}=${encodeURIComponent(
    fileName,
  )}`;
};

export const matchesDocumentFilename = (fileName, filenameParam) => {
  if (!fileName || !filenameParam) return false;
  return fileName === filenameParam;
};
